import { useIntl } from "react-intl";
import { SkinProductKey } from "~/api/models/SkinProductKey";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import FillerProductCard from "~/components/organisms/Pricing/FillerProductCard/FillerProductCard";
import useDefaultProduct from "~/hooks/useDefaultProduct";

const HyaluronidaseFillerCard = () => {
  const intl = useIntl();
  const { data: allProducts, isLoading } = useFetchProducts();
  const defaultProduct = useDefaultProduct(
    allProducts.skin.filler.hyaluronidase
  );

  return (
    <FillerProductCard
      skinProductFamilyKey={SkinProductKey.hyaluronidase}
      defaultProduct={defaultProduct}
      cardTitle={intl.formatMessage({
        id: "pricing.HyaluronidaseFiller",
      })}
      options={allProducts.skin.filler.hyaluronidase}
      blankOptionTitle={intl.formatMessage({
        id: "treatment.pricing.HyaluronidaseFiller.none",
      })}
      modalTitle={intl.formatMessage({
        id: "pricing.HyaluronidaseFiller",
      })}
      isLoading={isLoading}
    />
  );
};

export default HyaluronidaseFillerCard;
